<template lang="html">
  <h1 class="black--text" style="margin: 0 auto;">
    ◆限定版同梱物
  </h1>
  <div align="center">
    <v-img src="../assets/tokutenall.jpg" width="800">
      <template #sources>
        <source srcset="../assets/tokutenall.webp" width="800" />
      </template>
    </v-img>
  </div>
  <div style="text-align: center; font-size: 1.5em; line-height: 2.5em;">
    <p>・ゲーム「東方蒼神縁起V」&「東方幻想魔録W」ダブルパック」本体</p>
    <p>・東方蒼神縁起V 3枚組サウンドトラック</p>
    <p>・東方幻想魔録W 4枚組サウンドトラック</p>
    <p>・東方蒼神縁起V 副読本</p>
  </div>
</template>
